import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';
import { useCallback } from 'react';

export const useLogClickAiStudioConcept = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback(
    (title: string | null) => {
      logMarketAnalytics({
        name: 'CLICK_AI_STUDIO_CONCEPT',
        analytics: {
          TYPE: title,
        },
      });
    },
    [logMarketAnalytics],
  );
};
